


















































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Card from '@/components/Card.vue'
import BarChart from '@/components/chart/BarChart.vue'
import Avatar from '@/components/Avatar.vue'
import ScrollView from '@/components/ScrollView.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import Icon from '@/components/Icon.vue'
import { BillingModule } from '@/store/modules/billing.module'
import { IUser } from '@zunta/configurations'
const moment = require('moment')
const groupBy = require('lodash.groupby')
const uniq = require('lodash.uniq')

@Component({
  components: {
    Card,
    Icon,
    BarChart,
    Avatar,
    ScrollView,
    LoaderWrapper
  }
})
export default class SalesRepsPanel extends Vue {
  billingInstanceModule: BillingModule = getModule(BillingModule, this.$store);
  usersData: Array<any> = [];
  userStatistics: any = null;
  params: any = {};
  isLoading: boolean = false;
  mode: string = 'users'

  get salesRepStatistics () {
    return this.$store.state.billing.salesRepStatistics
  }

  get salesRepsData () {
    return this.$store.state.billing.salesRepsData
  }

  get displayUsersData () {
    return this.usersData.filter((userData: any) => {
      return !!userData.chains || !!userData.facilities
    })
  }

  async mounted () {
    await this.billingInstanceModule.fetchSalesRepsData()
    this.initUserData()
  }

  async showUserStatistics (user: IUser) {
    console.log('user', user)
    this.userStatistics = {
      user,
      data: []
    }
    this.mode = 'user-chart'
    this.params = {
      months: 7,
      skip: 0
    }
    await this.fetchSalesRepStatistics()
  }

  slideTo (skip: number) {
    this.params.skip += skip
    this.fetchSalesRepStatistics()
  }

  isPrevAvailable () {
    return this.userStatistics.data && this.userStatistics.data.length === 7
  }

  isNextAvailable () {
    return this.params.skip !== 0
  }

  goUsersMode () {
    this.mode = 'users'
  }

  async fetchSalesRepStatistics () {
    this.isLoading = true
    await this.billingInstanceModule.fetchSalesRepStatistics({
      userId: this.userStatistics.user.id,
      ...this.params
    })
    this.initUserStatisticsData()
    this.isLoading = false
  }

  initUserStatisticsData () {
    const maxChainsTotal = Math.max(...this.salesRepStatistics.statistics.chains.map((item: any) => item.lost + item.current))
    const maxFacilitiesTotal = Math.max(...this.salesRepStatistics.statistics.facilities.map((item: any) => item.lost + item.current))
    const maxTotal = Math.max(maxChainsTotal, maxFacilitiesTotal)
    const chainsGroup = groupBy(this.salesRepStatistics.statistics.chains, (chainData: any) => chainData.date)
    const facilityGroup = groupBy(this.salesRepStatistics.statistics.facilities, (facilityData: any) => facilityData.date)
    const keys = uniq([...Object.keys(chainsGroup), ...Object.keys(facilityGroup)])
    const data = keys.map((key: string) => {
      return {
        chains: chainsGroup[key] || [],
        facilities: facilityGroup[key] || [],
        date: new Date(key)
      }
    })
    this.userStatistics.data = data.map((dataItem: any) => {
      const date = new Date(dataItem.date)
      date.setHours(23)
      return {
        date,
        total: maxTotal,
        chainsChartData: dataItem.chains.map((item: any) => {
          return {
            total: maxChainsTotal,
            border: '#EDEDF2',
            items: [{
              value: item.lost,
              color: '#FF6633',
              label: 'Lost'
            }, {
              value: item.gained,
              color: '#FFDFBF',
              label: 'Gained'
            },
            {
              value: item.current - item.gained,
              color: 'rgb(235, 229, 248)',
              label: 'Current'
            }]
          }
        }),
        facilitiesChartData: dataItem.facilities.map((item: any) => {
          return {
            total: maxFacilitiesTotal,
            border: '#FFBE0B',
            items: [{
              value: item.lost,
              color: '#FF6633',
              label: 'Lost'
            }, {
              value: item.gained,
              color: '#FFDFBF',
              label: 'Gained'
            },
            {
              value: item.current - item.gained,
              color: 'rgb(235, 229, 248)',
              label: 'Current'
            }]
          }
        })
      }
    })
  }

  initUserData () {
    this.usersData = this.salesRepsData.map((data: any) => {
      const maxChainsTotal = Math.max(...data.statistics.chains.map((item: any) => item.lost + item.current))
      const maxFacilitiesTotal = Math.max(...data.statistics.facilities.map((item: any) => item.lost + item.current))

      return {
        user: data.user,
        chains: data.chains,
        facilities: data.facilities,
        chainsChartData: data.statistics.chains.map((item: any) => {
          return {
            total: maxChainsTotal,
            data: [{
              items: [{
                value: item.lost,
                color: '#FF6633',
                label: 'Lost'
              }, {
                value: item.gained,
                color: '#FFDFBF',
                label: 'Gained'
              },
              {
                value: item.current - item.gained,
                color: 'rgb(235, 229, 248)',
                label: 'Current'
              }]
            }]
          }
        }),
        facilitiesChartData: data.statistics.facilities.map((item: any) => {
          return {
            total: maxFacilitiesTotal,
            data: [{
              items: [{
                value: item.lost,
                color: '#FF6633',
                label: 'Lost'
              }, {
                value: item.gained,
                color: '#FFDFBF',
                label: 'Gained'
              },
              {
                value: item.current - item.gained,
                color: 'rgb(235, 229, 248)',
                label: 'Current'
              }]
            }]
          }
        })
      }
    })
  }
}
